module.exports = "<p>\r\n  monthly works!\r\n</p>\r\n"